import React from "react";
import { salesBundleMockup } from "../data/salesBundleMockup";
export function ProductMockup({
  priority = false
}: {
  priority?: boolean;
}) {
  return <img className="device-bundle-mockup" src={salesBundleMockup} alt="Sales Team Practice Ready Volume 1, with five workshops, shown on an iMac-style desktop, with its five bonus PDF covers on three tablets and two phones." width={1536} height={1024} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} decoding="async" data-id="element-106" data-mp="2thoc182uq1ky" />;
}